import { render, staticRenderFns } from "./EmotionRegulation.vue?vue&type=template&id=7ba94f3d&scoped=true&"
import script from "./EmotionRegulation.vue?vue&type=script&lang=js&"
export * from "./EmotionRegulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba94f3d",
  null
  
)

export default component.exports